/**
 * Csv Schema of CargaCorreios
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'

/* TODO: review generated schema */
export class CsvCargaCorreiosSchema extends Schema {
  readonly name = 'CsvCargaCorreios'

  readonly fieldSet: FieldSet<CargaCorreios> = {
    idCargaCorreiosPk: schema => schema.model.idCargaCorreiosPk,
    carga: schema => schema.model.carga?.$id ?? null,
    cdCorreios: schema => schema.model.cdCorreios,
  }
}
